
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesList from './components/ServicesList';
import ProcessSection from './components/ProcessSection';

const ServicesPage = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div className="bg-ivory min-h-screen">
      <Navigation />
      
      <main>
        <ServicesHero />
        
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <ServicesList />
        </motion.div>
        
        <ProcessSection />
      </main>
      
      <Footer />
    </div>
  );
};

export default ServicesPage;
